export default __webpack_public_path__ + "static/media/employeeNavigator.3b75fe3d.svg";